(ns pfo.coltype.component
  (:require [reagent.core :as reagent :refer [atom track!] :refer-macros [with-let]]
            #_:clj-kondo/ignore [taoensso.timbre :as timbre
             :refer [log trace debug info warn error fatal report logf
                     tracef debugf infof warnf errorf fatalf reportf spy]]
            [pfo.widget.upload :refer [upload-field]]
            [cljs-pikaday.reagent :as pikaday]
            [cljs-time.coerce :as time-coerce]
            [clojure.set :as set]
            [applied-science.js-interop :as j]
            [lentes.core :as l]
            [promesa.core :as p]
            [decimal.core :as dc]
            [goog.string :as gstring]
            [pfo.flash :refer [set-flash]]
            [pfo.widget.image :refer [image-view]]
            [clojure.string :as str :refer [lower-case]]
            ["react-select/creatable" :default CreatableSelect]
            ["react-select" :default Select :refer [createFilter components]]
            ["react-virtuoso" :refer [Virtuoso]]
            [malli.core :as m]
            [malli.instrument :as mi]
            [pfo.auth.model :as auth-model]
            [pfo.auth.component :as auth-component]
            [pfo.form :refer [set-checked checked?]]
            [pfo.admin.model :as admin-model]
            [pfo.task.model :as task-model]
            [pfo.document.model :as document-model]
            [pfo.collection.model :as collection-model]
            [pfo.collection.component :as collection-component]
            [pfo.coltype.model :as model :refer [flatten-fields get-attr-ref]]
            [pfo.coltype.spec :as spec]
            [pfo.coltype.components.common :refer [display-when-cta-warning-applicable cta-missing-fields-warning-text show-image-preview document-field-type]]
            [pfo.controller :as controller :refer [subscribe]]
            [pfo.assignment.component :refer [nav-search assignments-edit-modal get-initial-ui-assignments]]
            [pfo.util :as util :refer [add-uid]]
            [pfo.specutil :refer [warn-if-invalid fail-if-invalid!]]
            [pfo.revroutes :refer [path-for]]
            [pfo.api :as api :refer [process-error]]
            [pfo.tz :as tz]
            [pfo.state :as state]
            [pfo.common.model :refer [document-complex-name with-complex-names]]
            [pfo.common.component :as common]
            [pfo.widget.editor :refer [editor]]
            [pfo.widget.autocomplete :refer [react-select-styles]]
            [pfo.widget.timepicker :refer [datetimepicker]]))

(declare field-initlizers field-types field-type form-segment form-field string-field multi-choice-field
         field-from-value field-to-value flatten-map-values-that-are-maps field-error label-field document-field
         contact-details toggle-id-atom field-extra-values delete-from-replicable-visibility field-objects
         options-collection-data)

(def catom clojure.core/atom)
(def percentage-max-decimal-places 8)

(defn get-ref [field] (:ref field))
(defn get-deleted-ref [field] (str (:ref field) "__delete"))
(defn get-percentage-ref [field] (str (:ref field) "_percentage"))
(defn get-attr-other-ref [field attr] (str (get-attr-ref field attr) "_other")) ;; For attrs with secondary value ("other" choice)
(defn get-attr-object-ref [field attr] (str (get-attr-ref field attr) "_object"))
(defn get-xval-ref [field xval] (str (:ref field) "_" (:name xval)))
(defn get-objects-ref [field] (str (:ref field) "_objects"))

(defn has-value [field value-atoms]
  (let [val (model/get-form-value field value-atoms)]
    (cond
      (false? val) true
      :else (util/pytrue? val))))

(defn has-nested-value [field value-atoms]
  (model/has-nested-value field nil (fn [field _] (has-value field value-atoms))))

(defn- attrs-update [attr-k f]
  (fn [old-attrs]
    (let [old-view
          (into {}
            (map (fn [[item-id attr-dict]]
                   [item-id (get attr-dict attr-k)]))
            old-attrs)

          new-view (f old-view)]
      (reduce-kv
        (fn [m item-id v]
          (assoc m item-id
            (assoc (get m item-id {}) attr-k v)))
        old-attrs
        new-view))))

(defn- attr-lens [obj field attr attr-value-type]
  (let [attr-ref (case attr-value-type
                   :attr/main (keyword (:ref attr))
                   :attr/other (keyword (str (:ref attr) "_other"))
                   :attr/object (keyword (str (:ref attr) "_object")))]
    (l/derive
      (l/lens
        (fn [state]
          (let [attrs-k (keyword (str (get-ref field) "_attrs"))
                attr-k  attr-ref]
            (into {}
              (map (fn [[item-id attr-dict]]
                     [item-id (get attr-dict attr-k)]))
              (get state attrs-k))))

        (fn [state f]
          (let [attrs-k (keyword (str (get-ref field) "_attrs"))
                attr-k  attr-ref
                state (update state attrs-k (attrs-update attr-k f))
                updated-attrs (state attrs-k)
                updated-attrs-extra (into {} (map (fn [[obj-id attrs]]
                                                    [obj-id {:extra attrs}]) updated-attrs))]
            state
            ;; TODO: implement setting attr extra properly
            #_(update state attrs-k #_(keyword (get-objects-ref field)) util/deep-merge updated-attrs-extra))))
      obj)))

(defn get-field-value-atoms [obj field]
  (apply concat [[[(get-ref field) (l/derive (l/lens
                                               (fn [state]
                                                 ((field-from-value field) (get state (keyword (get-ref field)))))
                                               (fn [state f]
                                                 (let [ref (keyword (get-ref field))
                                                       current-value ((field-from-value field) (state ref))
                                                       updated-value (f current-value)]
                                                   (assoc state ref ((field-to-value field) updated-value))))) obj )]
                  [(get-deleted-ref field)
                   (l/derive (l/lens
                               (fn [state] (set (get state (keyword (get-deleted-ref field)))))
                               (fn [state f]
                                 (let [state (update state (keyword (get-deleted-ref field)) (comp f set))
                                       deleted-ids (set (map (comp keyword str) (get state (keyword (get-deleted-ref field)))))
                                       state (update state (keyword (get-objects-ref field))
                                               (fn [objects]
                                                 (into {} (for [[id obj] objects
                                                                :when (not (contains? deleted-ids id))]
                                                            [id obj]))))] state))) obj)]
                  [(get-percentage-ref field) (l/derive (l/lens
                                               (fn [state] (or (get state (keyword (get-percentage-ref field))) {}))
                                               (fn [state f] (update state (keyword (get-percentage-ref field)) f))) obj)]
                  [(get-objects-ref field) (l/derive (l/lens
                                               (fn [state] (or (get state (keyword (get-objects-ref field))) {}))
                                               (fn [state f] (update state (keyword (get-objects-ref field)) f))) obj)]]
                 (apply concat (mapv (fn [attr]
                                       [[(get-attr-ref field attr) (attr-lens obj field attr :attr/main)]
                                        [(get-attr-other-ref field attr) (attr-lens obj field attr :attr/other)]
                                        [(get-attr-object-ref field attr) (attr-lens obj field attr :attr/object)]]) (:attributes field)))
                 (mapv (fn [xval]
                         [(get-xval-ref field xval)
                          (l/derive (l/lens
                                      (fn [state] (get state (keyword (str (get-ref field) "_" (:name xval)))))
                                      (fn [state f] (update state (keyword (str (get-ref field) "_" (:name xval))) f))) obj )])
                   (field-extra-values field))]))

(defn get-to-value-by-ref [flattened-fields]
  (into {} (apply concat (map (fn [field]
                                (apply concat [[[(get-ref field) (field-to-value field)]
                                                [(get-deleted-ref field) #(into [] %)]
                                                [(get-percentage-ref field) (fn [value]
                                                                              (into {} (mapv (fn [[id percentage]]
                                                                                               [(str (get-percentage-ref field) "_id_" (name id))
                                                                                                percentage])
                                                                                         (into [] value))))]
                                                [(get-objects-ref field) (fn [& _])]]
                                               (mapv (fn [attr]  [(get-attr-ref field attr)
                                                                  (fn [value]
                                                                    (into {} (mapv (fn [[id attr-value]]
                                                                                     [(str (get-attr-ref field attr) "_id_" (name id))
                                                                                      ((field-to-value attr) attr-value)])
                                                                               (into [] value))))]) (:attributes field))
                                               (mapv (fn [attr]  [(get-attr-other-ref field attr)
                                                                  (fn [value]
                                                                    (into {} (mapv (fn [[id attr-value]]
                                                                                     [(str (get-attr-ref field attr) "_other" "_id_" (name id))
                                                                                      ((field-to-value attr) attr-value)])
                                                                               (into [] value))))]) (:attributes field))
                                               (mapv (fn [attr]  [(get-attr-object-ref field attr)
                                                                  (fn [_])]) (:attributes field))
                                               (mapv (fn [xval]  [(get-xval-ref field xval)
                                                                  (fn [value]
                                                                    (into {} (mapv (fn [[id xval-value]]
                                                                                     [(str (get-xval-ref field xval) "_id_" (name id))
                                                                                      ((field-to-value xval) xval-value)])
                                                                               (into [] value))))]) (field-extra-values field))]))
                           flattened-fields))))

(defn get-value-atoms [obj flattened-fields]
  (into {} (apply concat (map (fn [field] (get-field-value-atoms obj field)) flattened-fields))))

#_(defn get-field-objects []
  (map (fn [field]
         [(get-ref field)
          (atom (field-objects (options-collection-data options)
                  field))])
    (filter #(contains? (:data (:collection options))
               (keyword (get-objects-ref %)))
      flattened-fields)))

(defn get-field-objects-map [flattened-fields  col-data]
  (into {} (map (fn [field]
                  [(get-ref field)
                   (atom (field-objects col-data
                           field))])
             (filter #(contains? col-data
                        (keyword (get-objects-ref %)))
               flattened-fields))))

(defn collection-type-form [options form-def obj]
  (let [form-state (into
                     {}
                     (map
                       (fn [form]
                         [(:index form)
                          (let [flattened-fields (flatten-fields (:fields form))]
                            {:value-atoms (get-value-atoms obj flattened-fields)
                             :shared-atoms (into {} (map (fn [field] [(get-ref field) (atom nil)]) flattened-fields))
                             :to-value-by-ref (get-to-value-by-ref flattened-fields)
                             :save-success-atoms (into {} (mapv (fn [field] [(get-ref field) (atom false)]) (:fields form)))
                             :changed (atom false)
                             :changed-forms (:forms-change-status-atom options)
                             :skip-change (catom false)
                             :objects (get-field-objects-map flattened-fields (options-collection-data options))})])
                       (filterv identity (:forms form-def))))
        all-segment-ref-field-map (util/associate-by :ref
                                                     (filter
                                                      #(model/is-visible-by-dependency % (fn [aref] (get-in options [:collection :data (keyword aref)])))
                                                      (apply concat (map :fields (:forms form-def)))))
        all-value-atoms (apply merge (map :value-atoms (vals form-state)))
        entity-fields (model/get-entity-fields all-segment-ref-field-map)
        entity-ids (atom (set (filter identity (map (comp deref (fn [fld] (all-value-atoms (:ref fld)))) entity-fields))))
        entity-ref-field-maps (atom nil)
        entity-value-atoms (atom nil)
        entity-id-map (atom nil)
        entity-field-collection-field-atoms (map
                                              (fn [entity-field]
                                                [(:ref entity-field) (all-value-atoms (:entity_collection_ownership_field_ref entity-field))])
                                              (filter :self_entity entity-fields))
        load-entities (fn [ids]
                        (model/load-entities
                          {:get-values-for-fields-fn (fn [collection fields]
                                                       (get-value-atoms
                                                         (atom (:data collection))
                                                         fields))
                           :collection-id-value-map-cb (fn [cvmap]
                                                         (swap! entity-value-atoms merge cvmap))
                           :collection-id-fields-cb (fn [fmaps]
                                                      (swap! entity-ref-field-maps merge fmaps))
                           :collection-id-map-cb (fn [colmap]
                                                   (swap! entity-id-map merge colmap))}
                          ids))]
    (add-watch entity-ids :load-entities
      (fn [_ _ oldv newv]
        (load-entities (set/difference newv oldv))))
    (doseq [[entity-field-ref collection-field-value-atom] entity-field-collection-field-atoms]
      (add-watch collection-field-value-atom (str "colfield-watch-" entity-field-ref)
        (fn [& _]
          (let [collection-value (first @collection-field-value-atom)
                entity-atom (all-value-atoms entity-field-ref)]
            (when collection-value
              (swap! entity-ids conj collection-value))
            (when-not (= @entity-atom collection-value)
              (reset! entity-atom collection-value))))))
    (load-entities (into [] @entity-ids))
    
    (fn [options form-def obj]
      (let [all-segment-visible-ref-field-map (util/associate-by :ref
                                                                 (filter
                                                                  (fn [field]
                                                                    (model/is-visible field (fn [aref] (get-in options [:collection :data (keyword aref)]))))
                                                                  (apply concat (map (comp flatten-fields :fields) (:forms form-def)))))]
        [:div
         (doall
          (for [{:keys [index] :as form} (filterv identity (:forms form-def))]
            [:section {:key index :class (str "u-display--" (if (= (:active-form options) (:index form)) "block" "none"))}
             (when (= (:active-form options) (:index form)) [form-segment (assoc
                                                                           options
                                                                           :hide-form-label (:hide-form-labels options)
                                                                           :controls (get-in options [:form-controls (:active-form options)])
                                                                           :hide-continue-button (:hide-continue-button options)
                                                                           :all-segment-ref-field-map all-segment-ref-field-map
                                                                           :all-segment-visible-ref-field-map all-segment-visible-ref-field-map
                                                                           :all-value-atoms all-value-atoms
                                                                           :entity-value-atoms @entity-value-atoms
                                                                           :entity-id-map @entity-id-map
                                                                           :entity-ref-field-maps @entity-ref-field-maps)
                                                             (form-state index) form index @obj])]))]))))

(defn map-value-atom [collection field entity-value-atoms entity-ref-field-maps value-atoms]
  (let [field-value-atom (value-atoms (get-ref field))
        entity-field-ref (model/entity-field-ref field)
        entity-source-field-refs (model/entity-source-field-refs field)
        entity-attr-ref (model/entity-attr-ref field)
        entity-id-fn  #(deref (value-atoms entity-field-ref))
        is-entity-linked (and
                           (model/has-entity-link-config field)
                           (contains? value-atoms entity-field-ref)
                           (entity-id-fn))]
    (if is-entity-linked
      (if (and entity-value-atoms entity-ref-field-maps (entity-ref-field-maps (entity-id-fn)))
        (let [linked-entity-value-atoms (entity-value-atoms (entity-id-fn))
              entity-ref-field-map (entity-ref-field-maps (entity-id-fn))
              entity-field (some entity-ref-field-map entity-source-field-refs)
              entity-value-atom (if (not-empty entity-attr-ref)
                                  ;; Attribute mapping
                                  (let [attr ((util/associate-by :ref (:attributes entity-field))
                                              entity-attr-ref)
                                        attr-ref (get-attr-ref entity-field attr)
                                        owner-id (keyword
                                                   (str
                                                     (:owner_id (model/get-ownership-info entity-field-ref collection))))]
                                    (l/derive (l/key owner-id) (get-in entity-value-atoms [(entity-id-fn) attr-ref])))
                                  ;; Main value mapping
                                  (let [entity-value-atom (when linked-entity-value-atoms (some linked-entity-value-atoms entity-source-field-refs))]
                                    (cond (and
                                            (= "single_choice" (:type entity-field))
                                            (= "multi_choice" (:type field)))
                                          (l/derive (l/lens (fn [val] #{val}) (fn [& _])) entity-value-atom)
                                          ,
                                          :else entity-value-atom)))]
          (if entity-value-atom
            ;; There's main value mapping; remap also atoms for attributes and percentages
            (let [attribute-atoms (into {}
                                    (map
                                      ;; TODO: other attr, percentages, etc.
                                      (fn [attr]
                                        [(get-attr-ref field attr)
                                         (linked-entity-value-atoms (get-attr-ref entity-field attr))])
                                      (:attributes field)))]
              [entity-value-atom
               (merge
                 value-atoms
                 attribute-atoms)
               true
               (entity-id-fn)])
            (do
              (errorf
                "Field '%s' has override based on entity field '%s', but linked collection's template has no such field. Using non-override atom instead."
                (:ref field)
                entity-source-field-refs)
              [field-value-atom value-atoms false nil])))
        [(atom nil) value-atoms false nil])
      [field-value-atom value-atoms false nil])))

(defn visibility-value-fn
  "Looks up visibility dependencies in every form segment, so a field can depend
  on a field from another tab (#3192)."
  [options value-atoms]
  (let [atoms (or (:all-value-atoms options) value-atoms)]
    (fn [aref] (some-> (atoms (name aref)) deref))))

(defn form-segment [{:keys [] :as options} {value-atoms :value-atoms
                             to-value-by-ref :to-value-by-ref
                             save-success-atoms :save-success-atoms
                             changed :changed
                             changed-forms :changed-forms
                             skip-change :skip-change
                             objects :objects
                             :as form-state} form index obj]
  (doseq [[aref value-atom] value-atoms]
    (add-watch value-atom (str aref "-change-watch") (fn [_ _ old-value new-value]
                                                       (when-not (or @changed (= old-value new-value))
                                                         (when-not @skip-change
                                                           (reset! changed true))
                                                         (reset! skip-change false)))))

  (add-watch changed (str "changed") (fn [_ _ old-value new-value]
                                       (swap! changed-forms assoc
                                         (keyword  (str "coltype-form-" (:index form))) new-value)))

  (let [field-components (into {} (map (fn [field] [(get-ref field) (atom nil)]) (:fields form)))
        rerender-atom (atom false)]
    (fn [{:keys [controls
                 entity-value-atoms
                 entity-id-map
                 entity-ref-field-maps] :as options} form-state form index obj]
      (let [all-value-atoms (:all-value-atoms options)
            visible-fields (model/filter-by-replicable-visibility (filter #(model/is-visible % (visibility-value-fn options value-atoms)) (:fields form)) all-value-atoms)
            ref-field-map (util/associate-by :ref visible-fields)
            all-segment-ref-field-map (:all-segment-ref-field-map options)
            all-segment-visible-ref-field-map (:all-segment-visible-ref-field-map options)
            flattened-fields (flatten-fields (:fields form))
            last-index (dec (count visible-fields))
            cta-applies? (fn [type field]
                           ((case type
                              :highlight model/cta-highlight?
                              :warning model/cta-warning?)
                            field
                            (fn [ref] (model/get-form-value (all-segment-visible-ref-field-map ref) all-value-atoms))
                            (fn [ref value] ((field-to-value (all-segment-visible-ref-field-map ref)) value))))]
        [:div
         (when-not (:hide-form-label options)
           [:h1.u-flex {:style {:height (str (:header-height options) "px")}}
            (:label form)
            [:div.u-flex__element-to-right controls]])
         

         [:form.c-collection-template-roadmap__form.o-margin-elements--lg-vertical
          (when (or
                  (:created_at (:collection options))
                  (:updated_at (:collection options)))
            [:time.c-field-time
             [:p [:b "Created: "]  (some-> (:created_at (:collection options)) util/date-reformat)]
             [:p [:b "Modified: "] (some-> (:updated_at (:collection options)) util/date-reformat)]])

          (let [blank-cta-fields (remove
                                  #(has-nested-value % value-atoms)
                                  (filter #(and (cta-applies? :warning %) (not (= "label" (:type %)))) visible-fields))
                has-blank-cta-attrs (boolean
                                     (some true?
                                           (map
                                            (fn [fld]
                                              (let [selection-count (count @(value-atoms (:ref fld)))
                                                    cta-attr-set-counts (map
                                                                         (fn [attr]
                                                                           ;; count attributes that have values set
                                                                           (count (filter
                                                                                   (fn [attr-val]
                                                                                     (cond
                                                                                       (false? attr-val) true
                                                                                       (util/pytrue? attr-val) true
                                                                                       :else false))
                                                                                   (vals
                                                                                    ;; Only take values for keys corresponding to current selection
                                                                                    ;; in the choice field -- there can be leftover attribute values
                                                                                    ;; from earlier selections.
                                                                                    (select-keys
                                                                                     @(value-atoms (get-attr-ref fld attr))
                                                                                     ;; Convert IDs to keywords (235 -> :235)
                                                                                     ;; because this is the type of ID keys in attribute map
                                                                                     (map (comp keyword str) (model/get-form-value fld value-atoms)))))))
                                                                         (model/field-cta-attributes fld ref-field-map :edit))]
                                                (boolean (some #(< % selection-count) cta-attr-set-counts))))
                                            (model/unpack-fields (model/fields-with-cta-attrs flattened-fields) ref-field-map))))
                is-trust-with-no-interest (and
                                           (collection-model/is-trust-collection (:collection options))
                                           (not (nil? (all-segment-ref-field-map "has_interest")))
                                           ;; The field has inverse meaning in the UI:
                                           (model/get-form-value (all-segment-ref-field-map "has_interest") all-value-atoms))]

            (debug "Blank CTA fields" (map :ref blank-cta-fields) has-blank-cta-attrs)
            [display-when-cta-warning-applicable (:collection options)
             (when (and
                    (or (seq blank-cta-fields) has-blank-cta-attrs)
                    (not is-trust-with-no-interest))
               [:div.o-media.error.u-bold  cta-missing-fields-warning-text])])

          (doall
            (map-indexed
              (fn [index field]
                [:div {:key (:ref field)}
                 (when-not (contains? #{"label" "bool"} (:type field))
                   [:h4.u-margin-bottom
                    (when (cta-applies? :highlight field) {:class :u-color--highlighted})
                    (:label field)])
                 (when (:note field) [:div.c-note (:note field)])
                 (let [[mapped-value-atom 
                        value-atoms
                        is-entity-linked
                        linked-entity-id] (map-value-atom
                                            (:collection options)
                                            field
                                            entity-value-atoms
                                            entity-ref-field-maps
                                            value-atoms)]

                   [form-field (merge options
                                 {:value-atom mapped-value-atom
                                  :value-atoms value-atoms
                                  :deleted-value-atom (value-atoms (get-deleted-ref field))
                                  :percentage-value-atom (value-atoms (get-percentage-ref field))
                                  :save-success-atom (save-success-atoms (get-ref field))
                                  :label (:label field)
                                  :changed-atom changed
                                  :skip-change-atom skip-change
                                  :component (field-components (get-ref field))
                                  :shared-atom (get-in form-state [:shared-atoms (get-ref field)])
                                  :shared-atoms (:shared-atoms form-state)
                                  :form-fields flattened-fields
                                  :first (zero? index)
                                  :last (= last-index index)
                                  :rerender-atom rerender-atom
                                  :skip-change skip-change
                                  :cta-applies-fn cta-applies?
                                  :objects (if is-entity-linked
                                             (assoc objects
                                               (get-ref field)
                                               (atom (field-objects (get-in entity-id-map [linked-entity-id :data]) field)))
                                             objects)
                                  :disable is-entity-linked}) field])])
              visible-fields))

          (when-not (:hide-continue-button options)
            [:div.o-flex-align__element-floating-bottom-right
             [:button.o-flex-align--element-to-right
              (merge
                {:type :submit
                 :on-click
                 (fn [event]
                   (.preventDefault event)
                   (.stopPropagation event)
                   ;; check front-end html validation
                   (when (every? identity (map
                                            (fn [elem] (.reportValidity elem))
                                            (filter identity (map
                                                               (fn [field] @(field-components (get-ref field)))
                                                               (:fields form)))))
                     ((:save-func options)
                      {:form-data (merge {:form_index index}
                                    (flatten-map-values-that-are-maps
                                      (into {} (map (fn [[k v]] [k ((to-value-by-ref k) @v)])) value-atoms)))
                       :reset-changed-status-fn (fn []
                                                  (reset! changed false)
                                                  (swap! changed-forms assoc
                                                    (keyword  (str "coltype-form-" (:index form))) false)
                                                  (doall
                                                    (for [field (:fields form)]
                                                      (reset! (save-success-atoms (get-ref field)) true))))})))}
                (when-not @changed {:disabled :disabled})) "Continue"]])]]))))

(defn field-type [field] (keyword (:type field)))
(defn field-from-value [field]  (:from-value (field-types (field-type field))))
(defn field-to-value [field] (:to-value (field-types (field-type field))))
(defn field-success-cb [field] (:success-cb (field-types (field-type field))))
(defn field-extra-values [field] (:extra-values (field-types (field-type field))))

(defn flatten-map-values-that-are-maps [dict]
  (reduce (fn [value [k v]] (if (map? v) (merge value v) (assoc value k v))) {} dict))

(defn set-atom-value! [options value-atom value]
  (if-let [item-id (:attr-item-id options)]
    (swap! value-atom assoc item-id value)
    (reset! value-atom value)))

(defn set-atom-value-from-event [options atm]
  (fn [event]
    (let [value (-> event .-target .-value)]
      (if (= value "<CHOOSE>")
        (set-atom-value! options atm "")
        (set-atom-value! options atm value)))))

(defn get-atom-value [options value-atom]
  (if-let [item-id (:attr-item-id options)]
    (@value-atom item-id)
    @value-atom))

(defn form-field [options field]
  (fail-if-invalid! spec/form-field-options-spec options "Invaid form-field options")
  [(:component (field-types (keyword (:type field)))) options field])

(defn string-field [{:keys [skip-change value-atom] :as options} field ]
  (let [loader-ref (:default_value_loader_ref field)
        focused (atom false)]
    (when (and loader-ref (nil? (get-atom-value options value-atom)))
      (reset! skip-change true)
      (set-atom-value! options value-atom @(get-in options [:data-sources (keyword loader-ref)]))
      (reset! skip-change false))

  (fn [{value-atom :value-atom :as options} field]
    [:div {:class (or (:class options) (:string-field-class options)
                      (if (:editor field) "c-field-editor" "c-field-text"))}
     (if (:editor field)
       [:div.c-field-editor__wrapper [editor (merge
                                               {:rows 15}
                                               (when (:disable options) {:disabled :disabled})) value-atom]]
       (let [multi-row (> (:rows field) 1)]
         [(if multi-row
            :textarea
            :input)
          (merge
            (if multi-row
              {:rows (:rows field)}
              {:type :text})
            {:type "text"
             :class (when @focused :focused)
             :on-change (fn [ev]
                          ((set-atom-value-from-event options value-atom) ev)
                          (some-> (:on-change-cb options) (apply [ev])))
             :on-focus (fn [] (reset! focused true))
             :on-blur (fn [] (reset! focused false))
             :value (get-atom-value options value-atom)}
            (when-let [placeholder (:placeholder options)]
              {:placeholder placeholder})
            (when (> (:max_chars field) 0)
              {:maxlength (:max_chars field)})
            (when (:disable options) {:disabled :disabled}))]))
     [field-error options field]])))

(defn number-field [{value-atom :value-atom value-atoms :value-atoms :as options} field]
  (let [is-sum-field (boolean (:sum_fields field))
        to-decimal (fn [value]
                     (let [value-no-commas (clojure.string/replace value #"," "")
                           parsed-float (str (if (and (seq value) (not (js/Number.isNaN (js/parseFloat value-no-commas))))
                                               (js/parseFloat value-no-commas)
                                               0))]
                       (dc/to-string (dc/decimal parsed-float))))
        sum-calculate (fn []
                        (reduce dc/plus (map #(to-decimal %) (filter some? (map deref (map value-atoms (:sum_fields field)))))))]
    (when is-sum-field
      (doseq [ref (:sum_fields field)]
        (add-watch (value-atoms ref) (str "watch-" ref) (fn [_ _ old-value new-value]
                                                          (when-not (= old-value new-value)
                                                            (reset! value-atom (sum-calculate)))))))
    
    (fn [{value-atom :value-atom value-atoms :value-atoms :as options} field]
      [:div {:class "c-field-text"}
       [:span (when (:replicable field) {:style {:display "none"}})
        (when (:dollar field) [:span.c-field-unit "$"])
        [:input (merge
                 {:type "text" ; used to be number -- changed because of undesired behavior
                            ; number input specific attributes remain for now, but don't do anything
                  :on-change (util/reset-from-event value-atom)
                  :value @value-atom
                  :ref (fn [el] (reset! (:component options) el))}
                 (when (some true? (map field #{:dollar :percent})) {:style {:width "inherit"}})
                 (when-let [minv (not-empty (:min field))] {:min minv})
                 (when-let [stepv (not-empty (:step field))] {:step stepv})
                 (when (:disable options) {:disabled :disabled})
                 (when is-sum-field {:disabled :disabled}))]
        (when (:percent field) [:span.c-field-unit "%"])]
       [field-error options field]])))

(defn options-collection-data [options]
  (get-in options [:collection :data]))

(defn field-object-map [collection-data field]
  (get collection-data (keyword (str (get-ref field) "_objects"))))

(defn field-objects [collection-data field]
  (vals (field-object-map collection-data field)))


;; spec: needs collection in options
(defn field-export-key [options field]
  (get-in options [:collection :data (keyword (str  (get-ref field) "_export_key"))]))

(defn single-choice-field [options field]
  (let [all-choices-fn (fn [field-choices]
                         (or
                           (when field-choices (mapv (fn [[id label _]] [id {:component [:span nil label]}]) field-choices))
                           @((:data-sources options) (keyword (:loader_ref field)))))
        value-atom (:value-atom options)]

    (let [all-choices (all-choices-fn (:choices field))]
      (when (and (not (:allow_empty field)) (nil? (get-atom-value options value-atom)) (seq all-choices))
        (reset! (:skip-change-atom options) true)
        (if-let [item-id (:attr-item-id options)]
          (swap! value-atom assoc item-id (nth (first all-choices) 0))
          (reset! value-atom (nth (first all-choices) 0)))))

    (fn [{:keys [value-atom
                 value-atoms
                 other-choice-value-atom]
          :as options} field]
      (let [object-atom (value-atoms (str (:ref field) "_object"))
            all-choices (all-choices-fn (:choices field))
            all-choices-str-id-object-map (into {} (map (fn [[id {object :object}]]
                                                          [(str id) object]) all-choices))]
        [:div {:class (:single-choice-field-class options)
               :style (:style options)}
         [:select (merge
                    {:on-change (fn [event]
                                  (when (and other-choice-value-atom (not (model/is-other-choice-value field (-> event .-target .-value))))
                                    (set-atom-value! options other-choice-value-atom nil))
                                  ((set-atom-value-from-event options value-atom) event)
                                  (when object-atom
                                    (set-atom-value! options object-atom (all-choices-str-id-object-map (-> event .-target .-value)))))
                     :value (let [val (get-atom-value options value-atom)]
                              (if (nil? val)
                                ""
                                (str val)))}
                    (when (:disable options) {:disabled :disabled}))

          (when (:allow_empty field)
            [:option {:value "<CHOOSE>" :label (or (:empty_choice_label field) "")}])
          (for [[id {[_ _ label] :component}] all-choices]
            [:option {:value id
                      :key id} label])
          (when (and (:allow-other options) (not (:other_choice_use_existing_choice field)))
            [:option {:value "<OTHER>" :label (if (not-empty(:other-choice-label options)) (:other-choice-label options) "Other") }])]
         [field-error options field]
         (when (:allow_add_choice field)
           [:div.u-margin-top--xs
            [(options (keyword (:choice_adder_ref field)))]])]))))

(defn choice-item-input [{:keys [toggle-details
                                 deleted-value-atom
                                 percentage-value-atom
                                 value-atom]
                          :as options}
                         field id label]
  [:label [:input (set-checked
                         (contains? @value-atom id)
                         (merge
                          (when (:field-disabled options) {:disabled :disabled})
                          {:on-click (fn [ev]
                                      (let [selected (-> ev .-target .-checked)]
                                        (if selected
                                          (do
                                            (swap! value-atom conj id)
                                            (swap! deleted-value-atom disj id))
                                          (do
                                            (swap! value-atom disj id)
                                            (swap! deleted-value-atom conj id)
                                            (when (:has-number-field options)
                                              (swap! percentage-value-atom dissoc (keyword (str id))))))))}))]
        label
        (when toggle-details
          [:span.info.c-info {:on-click (util/handler (fn [] (toggle-details id)))} " ⓘ "])])

(defn percentage-input [{:keys [percentage-value-atom]
                         :as options} id]
  (let [id-keyword (keyword (str id))
        pre-validated-percentage (when (:has-number-field options) (atom (util/format-number-with-commas (@percentage-value-atom id-keyword))))
        ;; A seeded value the sum cannot read (an AARK tool argument, #3075)
        ;; must show on its own row, not only as a silently lower total.
        has-percentage-error (atom (when (:has-number-field options)
                                     (util/unreadable-decimal? (@percentage-value-atom id-keyword))))]
    (when (:has-number-field options)
          (add-watch (:rerender-atom options) (str "test watch" id-keyword)
                     (fn [_ _ old new]
                       (reset! pre-validated-percentage
                               (when (:has-number-field options) (util/format-number-with-commas (@percentage-value-atom id-keyword))))
                       (reset! has-percentage-error (util/unreadable-decimal? (@percentage-value-atom id-keyword)))))
          (when-let [save-success-atom (:save-success-atom options)]
            (add-watch save-success-atom (str "save-success-format-watch " id-keyword)
                       (fn [_ _ _ news]
                         (when news
                           (reset! pre-validated-percentage (util/format-number-with-commas (@percentage-value-atom id-keyword)))
                           (reset! has-percentage-error (util/unreadable-decimal? (@percentage-value-atom id-keyword)))
                           (reset! save-success-atom false))))))
    (fn [options]
      (when (:has-number-field options)
        [:span.c-field-percentage
         [:input {:placeholder "0"
                  :class (when @has-percentage-error :error)
                  :value @pre-validated-percentage
                  :on-change (fn [event]
                               (let [value (clojure.string/trim (-> event .-target .-value))
                                     value-no-commas (clojure.string/replace value #"," "")
                                     ;; two or more dots in a grouped pattern mean thousands separators, not a decimal point
                                     grouped-dots? (and (re-matches #"-?\d{1,3}(\.\d{3})+\.?" value-no-commas)
                                                        (>= (count (re-seq #"\." value-no-commas)) 2))
                                     value-normalized (if grouped-dots?
                                                        (clojure.string/replace value-no-commas #"\." "")
                                                        (let [no-trailing-dot (if (clojure.string/ends-with? value-no-commas ".")
                                                                                (subs value-no-commas 0 (dec (count value-no-commas)))
                                                                                value-no-commas)
                                                              last-dot (clojure.string/last-index-of no-trailing-dot ".")]
                                                          ;; with multiple dots left, only the last one is the decimal point
                                                          (if (and last-dot (>= (count (re-seq #"\." no-trailing-dot)) 2))
                                                            (str (clojure.string/replace (subs no-trailing-dot 0 last-dot) #"\." "") (subs no-trailing-dot last-dot))
                                                            no-trailing-dot)))]
                                 (try
                                   (let [decimal-value (dc/to-string (dc/to-decimal-places
                                                                       (dc/decimal value-normalized)
                                                                       percentage-max-decimal-places
                                                                       (dc/round-mapping :round-down)))]
                                     (swap! percentage-value-atom assoc id-keyword decimal-value)
                                     (reset! has-percentage-error false)
                                     (if (or (clojure.string/ends-with? value ".") (clojure.string/ends-with? value "0") (clojure.string/includes? value ","))
                                       (reset! pre-validated-percentage value)
                                       (reset! pre-validated-percentage decimal-value)))
                                   (catch :default e
                                     (reset! has-percentage-error true)
                                     (reset! pre-validated-percentage value)
                                     (swap! percentage-value-atom assoc id-keyword "0")))))}]
         (when (not (:has-units-selected options)) [:span.percent "%"] )]))))

(defn choice-item-with-attrs [{value-atoms :value-atoms
                               controls :controls
                               :as options} field id label]
  [:tr {:key id}
   [:td
    [choice-item-input options field id label]]
   (when (:has-number-field options)
     [:td [percentage-input options id]])
   (when (:show-attributes options)
     (doall
      (for [attr (model/visible-attrs field (fn [ref] (model/get-form-value ((:all-segment-ref-field-map options) ref) value-atoms)))]
        [:td.attr {:key (:ref attr)}
         [form-field (merge options
                            {:attr-item-id (keyword (str id))
                             :value-atom (value-atoms (get-attr-ref field attr))
                             :other-value-atom (value-atoms (get-attr-other-ref field attr))
                             :single-choice-field-class "u-inline"
                             :string-field-class "u-inline"})
          (update attr :ref (fn [ref-value] (str (:ref field) "_" ref-value)))]])))
   (when controls [:td controls])])

(defn choice-item [options field id label]
  [:span.c-field-inline--small
   [choice-item-input options field id label]
   [percentage-input options id]])

(def choices-menu-list
  (reagent/reactify-component
    (fn [props]
      [:> Virtuoso
       {:style {:height "400px"}
        :data (:children props)
        :itemContent (fn [index elem] elem)}])))
(def Option (.-Option components))

(def choices-list-option
  (reagent/reactify-component
    (fn [props]
      [:> Option
       (merge
         (update props :innerProps
           (fn [inner-props]
             (j/assoc! inner-props :onMouseOver nil :onMouseMove nil)
             inner-props))
         (when-let [list-label (get-in (js->clj props) [:data "listLabel"])]
           {:children list-label}))])))

(defn percentage-summary [{:keys [has-units-selected
                                  percentage-value-atom]
                           :as options}]
  (if (and (:has-number-field options) (not has-units-selected))
    (let [sum (util/sum-decimals (vals @percentage-value-atom))
          invalid (not (dc/= sum 100))]
      [:p [:span.percentage.total {:class (if invalid "invalid" "")} (if invalid "Sum (must be less than or equal 100%): " "Sum: ") (dc/to-string sum) "%"]])
    [:div]))

(defn selected-choices-as-list [{:keys [has-units-selected
                                        percentage-value-atom]
                                 :as options}
                                toggle-options choices field]
  [:div
   [:ul {:class (when (:has-number-field options) "percentage c-field-multi-choice__share-percentage")}
    (for [[id {label :component}] choices]
      [:li {:key id} [choice-item (merge options toggle-options)
                      field id label]])]
   [percentage-summary options]])

(defn selected-choices-as-table [{:as options}
                                 toggle-options choices field]
  [:div
   [:table.c-field-multi_choice_with_attrs__choices
    [:tbody.selected
     [:tr
      [:th]
      (when (:has-number-field options)
        [:th.attr (:units-selected-label field)])
      (doall
       (for [attr (model/visible-attrs field (fn [ref] (model/get-form-value ((:all-segment-ref-field-map options) ref) (:value-atoms options))))]
          [:th.attr (merge
                      {:key (:ref attr)}
                      (when (:cta attr) {:class :u-color--highlighted}))
           (:label attr)]))]
     (doall
       (for [[id {label :component
                  :as label-component}] choices]
         ^{:key id} [choice-item-with-attrs (merge (assoc options :show-attributes true) toggle-options )
                     field id (or label label-component)]))]]
   [percentage-summary options]])

(m/=> selected-choices-as-table [:=> [:cat
                                      [:map
                                       [:has-units-selected {:optional true} [:maybe :boolean]]]
                                      [:maybe {:desc "toggle options"} [:map]]
                                      [:maybe [:sequential {:desc "choices"} [:tuple :int :any]]]
                                      :map] :any])

(defn multi-field-selected-choices-as-table
  [{:keys [value-atoms has-number-field] :as options} toggle-options attributes choices-with-fields]
  [:div
   [:table.c-field-multi_choice_with_attrs__choices
    [:tbody.selected
     [:tr
      [:th]
      (when (:has-number-field options)
        [:th.attr (:units-selected-label options)])
      (doall
       (for [attr attributes]
          [:th.attr (merge
                      {:key (:ref attr)}
                      (when (:cta attr) {:class :u-color--highlighted}))
           (:label attr)]))
      (when-let [controls-label (:controls-label options)]
        [:th controls-label])]
     (doall
       (for [{:keys [id label field controls]} choices-with-fields]
         ^{:key id} [choice-item-with-attrs
                     (merge (assoc options :show-attributes true
                              :value-atom (value-atoms (get-ref field))
                              :deleted-value-atom (value-atoms (get-deleted-ref field))
                              :percentage-value-atom (value-atoms (get-percentage-ref field))
                              :controls controls) toggle-options )
                     field id label]))]]
   [percentage-summary (assoc options
                         :percentage-value-atom
                         (catom
                           (apply concat
                             (map (fn [fref] @(value-atoms (get-percentage-ref {:ref fref})))
                               (set (map (comp :ref :field) choices-with-fields))))) )]])

(defn export-field [options field]
  (let [key (:value-atom options)
        error         (atom nil)
        import-error  (atom nil)
        import-result (atom nil)
        import?       (atom false)
        collection-id (:id (:collection options))
        changed-atom (:changed-atom options)
        value-atoms (:value-atoms options)
        form-fields-map (util/associate-by :ref (:form-fields options))
        percentage_user_field_ref (:percentage_user_field_ref field)
        collection_field_ref (:collection_field_ref field)
        export-field-changed (atom nil)
        export-field-refs (concat
                           [(:unit_selector_field_ref field)
                            percentage_user_field_ref 
                            collection_field_ref 
                            (get-percentage-ref {:ref percentage_user_field_ref}) 
                            (get-percentage-ref {:ref collection_field_ref})]
                           (vec (map #(str percentage_user_field_ref "_" %) (map :ref (:attributes (form-fields-map percentage_user_field_ref)))))
                           (vec (map #(str collection_field_ref "_" %) (map :ref (:attributes (form-fields-map collection_field_ref))))))]

    (doseq [[idx value-atom] (map-indexed vector (map value-atoms (filter some? export-field-refs)))]
      (add-watch value-atom (str "value-atom-" idx)
                 (fn [_ _ old new]
                   (when-not (= old new) (reset! export-field-changed true)))))

    (add-watch changed-atom "changed-atom-to-false"
               (fn [_ _ old new]
                 (when (and old (not new))
                       (reset! export-field-changed nil)
                       (reset! import-error nil)
                       (reset! import? nil))))
    (fn [options field]
      (when key
            [:div
             [:form
              {:method :post
               :action (str "/download/ownership_export/")}
              [:input
               {:type  :hidden
                :name  :key
                :value @key}]
              [:span.controls
               [:button
                (when @export-field-changed
                      {:disabled :disabled
                       :title    "Save data before export"})
                "Export"]]
              " "
              [:span.controls
               (when-not @import?
                         [:button
                          (merge
                           {:on-click (util/handler
                                       (fn []
                                         (reset! import? true)))
                            :href     "#"}
                           (when @export-field-changed
                                 {:disabled :disabled
                                  :title    "Save data before import"}))
                          "Import"])]]
             (when @import?
                   [:div
                    [:dl
                     [:dt "CSV file:"]
                     [:dd
                      [upload-field
                       {:url         (api/api-url (str "/collection/" collection-id "/ownership_validate/"))
                        :error-cb    (fn [err]
                                       (reset! error "Import failed. Try again later."))
                        :success-cb  (fn [e response]
                                       (reset! error nil)
                                       (reset! import-result (js->clj response :keywordize-keys true))
                                       (let [value-atoms (:value-atoms options)]
                                         (if-not (:error @import-result)
                                               (do
                                                 (doseq [field
                                                       (flatten-fields
                                                        (map form-fields-map [percentage_user_field_ref collection_field_ref]))]
                                                 (reset!
                                                  (get value-atoms
                                                       (get-percentage-ref field))
                                                  (or (get @import-result (keyword (get-percentage-ref field))) {}))
                                                 (doseq [attr (:attributes field)]
                                                   (let [item-attrs (get @import-result (keyword (str (get-ref field) "_attrs")))]
                                                     (reset! (get value-atoms (get-attr-ref field attr))
                                                             (or
                                                              (into {}
                                                                    (mapv (fn [[item-id attr-dict]] [item-id (attr-dict (keyword (:ref attr)))]) item-attrs))
                                                              {})))))
                                               (set-flash :success (str "Import successful" (when-not @export-field-changed ", but no changes have been made")))
                                               (reset! import? false)
                                               (swap! (:rerender-atom options) not))
                                                 (reset! import-error (:error @import-result)))))
                        :post-params {:collection_id collection-id :ref (:ref field)}}]]]
                    [:span.error @error]
                    (when import-error
                          [:div
                           (case (:type @import-error)
                                 "missing_owners" [:div
                                                   [:p.error (:message @import-error)]
                                                   (doall
                                                    [:ul.u-disc-list
                                                     (for [value (:values @import-error)]
                                                       [:li value])])]
                                 [:p.error (:message @import-error)])
                           [:ul
                            (doall
                             (for [row-error (:errors @import-error)]
                               [:li
                                "Errors in row "
                                (:idx row-error)
                                ":"
                                [:ul.u-disc-list
                                 (doall
                                  (for [value-error (:errors row-error)]
                                    [:li (:message value-error)]))]]))]])
                    [:span.controls
                     [:button
                      {:on-click (util/handler
                                   (fn []
                                     (reset! import? false)
                                     (reset! import-error nil)))}
                      "Cancel import"]]])]))))

(defn get-field-settings [collection field]
  (get-in collection [:data (keyword (str (get-ref field) "_options"))]))

(defn field-disabled? [settings]
  (true? (:disable settings)))

(defn multi-choice-field [{:keys [data-sources
                                  as-table
                                  other-field]
                           :as options} field]
  (let [value-atom (:value-atom options)
        deleted-value-atom (:deleted-value-atom options)
        unit-selector-atom (:unit-selector-atom options)
        other-choice-value-atom (:other-choice-value-atom options)
        other-choice-selected (atom (boolean (when other-choice-value-atom (not-empty @other-choice-value-atom))))
        search-term (atom nil)
        separate-chosen (:separate_chosen field)
        choices-atom (or ((:data-sources options) (keyword (:loader_ref field))) (atom (map (fn [[id label _]] [id {:component label}]) (:choices field))))
        choice-object-map (when-let [choices ((:data-sources options) (keyword (:loader_ref field)))]
                         (util/associate-by :id (map (comp :object second) @choices)))
        settings     (get-field-settings (:collection options) field)
        details-components-atom (track! (fn [] (when-let [source (data-sources (keyword (str (:loader_ref field) "_details")))] @source)))
        details-component (atom nil)
        last-id (catom nil)
        toggle-options (when (seq @details-components-atom)
                         {:toggle-details (fn [id]
                                            (if (not= id @last-id)
                                              (do (reset! details-component (get-in @details-components-atom [id :component])) (reset! last-id id) )
                                              (do (reset! details-component nil) (reset! last-id nil) )))})]

    (fn [{:keys [value-atom value-atoms]
          :as options} field]
      (let [selected-choices-atom (track! (fn [] (filterv #(contains? @value-atom (first %)) @choices-atom)))
            non-selected-choices (fn []
                               (filterv
                                 #(not (contains? @value-atom (first %)))
                                 (if (and (:filter field) (util/to-value @search-term))
                                   (filterv (fn [[_ [_ _ label]]]
                                              (gstring/contains (lower-case label) (lower-case @search-term))) @choices-atom)
                                   @choices-atom)))
            disabled (or (field-disabled? settings) (field-disabled? options))
            has-units-selected (when unit-selector-atom (not= @unit-selector-atom "percentage"))
            options (if disabled (assoc options :field-disabled disabled) options)]
        [:div.c-field-multi_choice_with_attrs.o-margin-elements--md-vertical
         (when (and
                 separate-chosen
                 (seq @value-atom)
                 (not (:hide_selected_choices field)))
           [:div (when (and (not disabled) (= "context_permitted_users" (:loader_ref field)))
                   [:span.c-note "Note: This selection does not grant access"])
            (if as-table
              [selected-choices-as-table
               (assoc options
                 :has-units-selected has-units-selected)
               toggle-options @selected-choices-atom field]
              [selected-choices-as-list
               (assoc options
                 :has-units-selected has-units-selected)
               toggle-options @selected-choices-atom field])])

         [field-error options field]
         (when (or (not disabled) (not separate-chosen))
           (let [choices (if separate-chosen (non-selected-choices) @choices-atom)]
           (if (and (:filter field) separate-chosen)
             [:> Select
              (merge
               {:isDisabled (:field-disabled options)}
                {:options (sort-by
                            :label
                            (mapv (fn [[id {component-label :component}]]
                                    (let [[_ attrs label] component-label
                                          has-component-label (= 3 (count component-label))
                                          details (when (contains? @details-components-atom id) (@details-components-atom id))]
                                      {:label (if has-component-label label component-label)
                                       :listLabel (if has-component-label
                                                    (if (= "contact" (:class attrs))
                                                      (reagent/as-element
                                                        [:div.contact label " " [:div.info "ⓘ" [:div.details-component details]]]) label)
                                                    component-label)
                                       :value id})) choices))
                 :placeholder (:placeholder field "Select from ALL Family Contact with Credentials")
                 :on-change (fn [e]
                              (let [ev (js->clj e :keywordize-keys true)
                                    value (:value ev)]
                                (swap! value-atom conj value)
                                (swap! deleted-value-atom disj value)
                                (when choice-object-map
                                  (swap!
                                    (value-atoms (get-objects-ref field))
                                    assoc
                                    (keyword (str value))
                                    (choice-object-map value)))))
                 :filterOption (createFilter (clj->js {:ignoreAccents false}))
                 :value nil
                 :components {:MenuList choices-menu-list
                              :Option choices-list-option}}
                (:primary react-select-styles))]
             [:ul
              (doall
                (for [[id {label :component}] (if separate-chosen (non-selected-choices) @choices-atom)]
                  [:li {:key id} [choice-item (merge
                                                (assoc options :has-number-field false)
                                                toggle-options ) field id label]  ]))
              (when (:allow-other options)
                [:li {:key "__other__"}
                 [:span.label [:label [:input (set-checked
                                                @other-choice-selected
                                                {:on-click (fn [ev]
                                                             (let [selected (-> ev .-target .-checked)]
                                                               (reset! other-choice-selected selected)
                                                               (when-not selected (reset! other-choice-value-atom nil))))})]
                               [:span " "
                                (:other-choice-label options)
                                ": "
                                [string-field (merge options
                                                {:value-atom other-choice-value-atom
                                                 :on-change-cb (fn [_]
                                                                 (reset! other-choice-selected (not-empty @other-choice-value-atom)) )
                                                 :placeholder "Describe"}
                                                (if (> (:rows other-field) 1)
                                                  {:string-field-class ""}
                                                  {:string-field-class "u-inline"}))
                                 other-field]]]]])])))


         (when @details-component
           @details-component)

         (when (and (:allow_add_choice field) (not disabled))
           [(options (keyword (:choice_adder_ref field)))])]))))



(defn multi-choice-percentage-field [options field]
  [multi-choice-field (merge options {:has-number-field true}
                        (when (seq (:attributes field))
                          {:as-table true})) field])

(defn multi-choice-with-other-field [{value-atoms :value-atoms
                                      :as options}
                                     {[choice-field other-field] :subfields
                                      :as field}]
  [:div.c-field-multi-choice-with-other
   [multi-choice-field
    (merge options {:allow-other true
                    :value-atom (value-atoms (get-ref choice-field))
                    :deleted-value-atom (value-atoms (get-deleted-ref choice-field))
                    :other-choice-value-atom (value-atoms (get-ref other-field))
                    :other-choice-label (:label other-field)
                    :other-field other-field})
    (merge field {:choices (:choices choice-field)})]])

(defn single-choice-with-other-field [{value-atoms :value-atoms
                                      :as options}
                                     {[choice-field other-field] :subfields
                                      :as field}]
  (let [choice-field-value-atom (or (:value-atom options) (value-atoms (get-ref choice-field)))
        other-field-value-atom (or (:other-value-atom options) (value-atoms (get-ref other-field)))]
    [:div.c-field-multi-choice-with-other (when (:attr-item-id options) {:class :attr-with-other})
     [single-choice-field
      (merge options {:allow-other true
                      :value-atom choice-field-value-atom
                      :deleted-value-atom (value-atoms (get-deleted-ref choice-field))
                      :other-choice-value-atom other-field-value-atom
                      :other-choice-label (:label other-field)})
      (merge field {:choices (:choices choice-field)
                    :loader_ref (:loader_ref choice-field)
                    :allow_empty (:allow_empty choice-field)
                    :empty_choice_label (:empty_choice_label choice-field)
                    :other_choice_use_existing_choice (:other_choice_use_existing_choice choice-field)})]
     (when (model/is-other-choice-value choice-field (get-atom-value options choice-field-value-atom))
       [string-field (assoc options
                       :value-atom other-field-value-atom
                       :placeholder "Describe")])]))

(defn date-field [options field]
  [:div.c-field-date {:class (:class options)}
   [pikaday/date-selector {:date-atom (:value-atom options)}]
   [field-error options field]])

(def month-days
  {"1" 31
   "2" 28
   "3" 31
   "4" 30
   "5" 31
   "6" 30
   "7" 31
   "8" 31
   "9" 30
   "10" 31
   "11" 30
   "12" 31})

(defn month-day-field [{value-atoms :value-atoms
                        :as options}
                       {[month-field day-field] :subfields
                        :as field}]
  (let [month-field-value-atom (value-atoms (get-ref month-field))
        day-field-value-atom (value-atoms (get-ref day-field))]
    (add-watch month-field-value-atom :month-change
      (fn [_ _ _ new-month]
        (when (empty? new-month) (reset! day-field-value-atom nil))
        (when-not @day-field-value-atom (reset! day-field-value-atom 1))))
    (fn []
      [:div.c-field-inline {:class (:class options)}
       [single-choice-field (assoc options
                              :value-atom month-field-value-atom
                              :single-choice-field-class :c-field-inline__field
                              :style {:width "25%"}) month-field]
       [single-choice-field
        (assoc options
          :value-atom day-field-value-atom
          :single-choice-field-class :c-field-inline__field)
        (assoc day-field
          :choices (if @month-field-value-atom
                     (into [] (map (fn [num] [num num])(range 1 (inc (if @month-field-value-atom
                                                                       (month-days @month-field-value-atom)
                                                                       (month-days "1"))))))
                     [])
          :allow_empty (empty? @month-field-value-atom)
          :empty_choice_label "Choose day")]
       [field-error options field]])))

(defn address-field [{:keys [value-atoms 
                             entity-value-atoms
                             entity-ref-field-maps]
                      :as options}
                     {[line1-field line2-field city-field state-field zip-field us-territory-field] :subfields
                      :as #_:clj-kondo/ignore field}]
  (let [field-atom (fn [afield]
                     (first (map-value-atom
                       (:collection options)
                       afield
                       entity-value-atoms
                       entity-ref-field-maps
                       value-atoms)))]
    [:div.group-fields.o-margin-elements--lg-vertical
     [:div.text-field.c-field-inline 
      [:label.c-field-inline__label "Street Address"]
      [:input.c-field-inline__field {:type "text"
                                     :placeholder "Street Address" :on-change (util/reset-from-event (field-atom line1-field))
                                     :value @(field-atom line1-field)}]]
     [field-error options line1-field]

     [:div.text-field.c-field-inline
      [:label.c-field-inline__label "Suite/Unit Number"]
      [:input.c-field-inline__field {:type  "text"
                                     :placeholder "Suite/Unit Number" :on-change (util/reset-from-event (field-atom line2-field))
                                     :value @(field-atom line2-field)}]]
     [field-error options line2-field]

     [:div.text-field.c-field-inline 
      [:label.c-field-inline__label "City"]
      [:input.c-field-inline__field {:type  "text"
                                     :placeholder "City" :on-change (util/reset-from-event (field-atom city-field))
                                     :value @(field-atom city-field)}]]
     [field-error options city-field]

     [:div.text-field.c-field-inline
      [:label.c-field-inline__label "State"]      
      [single-choice-field (assoc options
                                  :value-atom (field-atom state-field)
                                  :single-choice-field-class :c-field-inline__field) state-field]]    
     [field-error options state-field]

     [:div.text-field.c-field-inline 
      [:label.c-field-inline__label "Zip Code"]
      [:input.c-field-inline__field {:type "text"
                                     :placeholder "Zip Code" :on-change (util/reset-from-event (field-atom zip-field))
                                     :value @(field-atom zip-field)}]]
     [field-error options zip-field]
     
     [:div.text-field.c-field-inline
      [:label.c-field-inline__label "US or US Territory"]
      [single-choice-field (assoc options
                                  :value-atom (field-atom us-territory-field)
                                  :single-choice-field-class :c-field-inline__field) us-territory-field]]
     [field-error options us-territory-field]]))

(defn intl-address-field [{:keys [value-atoms
                                  entity-value-atoms
                                  entity-ref-field-maps]
                           cta-applies-fn :cta-applies-fn
                           :as options}
                          {[line1-field line2-field city-field state-field province-field zip-field country-field] :subfields
                           :as field}]
  (let [field-atom (fn [afield]
                     (map-value-atom
                       (:collection options)
                       afield
                       entity-value-atoms
                       entity-ref-field-maps
                       value-atoms))]
    [:div.group-fields.o-margin-elements--lg-vertical
     (let [[fatom _ is-entity-linked] (field-atom line1-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "Street Address"]
        [:input.c-field-inline__field (merge
                                        {:type "text"
                                         :placeholder "Street Address" :on-change (util/reset-from-event fatom)
                                         :value @fatom}
                                        (when is-entity-linked {:disabled :disabled}))]])
     [field-error options line1-field]

     (let [[fatom _ is-entity-linked] (field-atom line2-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "Suite/Unit Number"]
        [:input.c-field-inline__field (merge
                                        {:type "text"
                                         :placeholder "Suite/Unit Number" :on-change (util/reset-from-event fatom)
                                         :value @fatom}
                                        (when is-entity-linked {:disabled :disabled}))]])
     [field-error options line2-field]

     (let [[fatom _ is-entity-linked] (field-atom city-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "City"]
        [:input.c-field-inline__field (merge
                                        {:type "text"
                                         :placeholder "City" :on-change (util/reset-from-event fatom)
                                         :value @fatom}
                                        (when is-entity-linked {:disabled :disabled}))]])
     [field-error options city-field]

     (let [[fatom _ is-entity-linked] (field-atom state-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "State"]
        [single-choice-field (assoc options
                               :value-atom fatom
                               :single-choice-field-class :c-field-inline__field
                               :disable (boolean is-entity-linked))
         state-field]])
     [field-error options state-field]

     (let [[fatom _ is-entity-linked] (field-atom province-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label "Province"]
        [:input.c-field-inline__field (merge
                                        {:type "text"
                                         :placeholder "Province" :on-change (util/reset-from-event fatom)
                                         :value @fatom}
                                        (when is-entity-linked {:disabled :disabled}))]])
     [field-error options province-field]

     (let [[fatom _ is-entity-linked] (field-atom zip-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "Zip/Postal Code"]
        [:input.c-field-inline__field (merge
                                        {:type "text"
                                         :placeholder "Zip/Postal Code" :on-change (util/reset-from-event fatom)
                                         :value @fatom}
                                        (when is-entity-linked {:disabled :disabled}))]])
     [field-error options zip-field]

     (let [[fatom _ is-entity-linked] (field-atom country-field)]
       [:div.text-field.c-field-inline
        [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) "Country"]
        [single-choice-field (assoc options
                               :value-atom fatom
                               :single-choice-field-class :c-field-inline__field
                               :disable (boolean is-entity-linked))
         country-field]])
     [field-error options country-field]]))

(defn field-group [{:keys [value-atoms
                           objects]} _]
  (let [collapsed? (atom false)]
    (fn [{:keys [entity-value-atoms
                 entity-ref-field-maps]
          :as options} field]
      (let [visible-fields (filter #(model/is-visible % (visibility-value-fn options value-atoms)) (:subfields field))
            replicable? (not-empty (:replicable_visibility_ref field))
            replicable-value-atom (value-atoms (:replicable_visibility_ref field))
            replicable-value (when replicable-value-atom 
                               (let [replicable-value (js/parseInt @replicable-value-atom)]
                                 (if (js/isNaN replicable-value) 1 replicable-value)))
            last-replicable? (if replicable? 
                               (= (-> (:ref field) (str/split #"_") last js/parseInt) replicable-value)
                               false)]
        [:div {:class (apply util/classes [(when-not (:last options) :u-border-bottom--lg)
                                           (when-not (:last options)
                                             (if @collapsed?
                                               :u-padding-bottom
                                               :u-padding-bottom--lg))
                                           (when-not (:first options) :u-margin-top)])}
         (doall
          (for [subfield (cons
                          (assoc (first visible-fields)
                                 :expander true)
                          (when-not @collapsed? (rest visible-fields)))]
            [:div
             {:key (:ref subfield)}
             (when (not-empty (:label subfield)) [label-field (assoc options
                                                                     :collapsed-atom collapsed?) subfield])
             (when-not @collapsed?
               (form-field
                (merge options
                       (let [[mapped-value-atom _ is-entity-linked] (map-value-atom
                                                                     (:collection options)
                                                                     subfield
                                                                     entity-value-atoms
                                                                     entity-ref-field-maps
                                                                     value-atoms)]
                         {:value-atom mapped-value-atom
                          :deleted-value-atom (value-atoms (get-deleted-ref subfield))
                          :shared-atom ((:shared-atoms options) (get-ref subfield))
                          :disable is-entity-linked}))
                subfield))]))
         (when replicable?
           [:div.o-flex-align--right
            (when last-replicable?
              [:button.u-margin-right--xs (merge
                                           {:on-click (util/handler (fn []
                                                                      (reset! replicable-value-atom (inc replicable-value))))}
                                           (when (= replicable-value (:replicable_fields_count field)) {:disabled :disabled})) "Add Another"])
            (when (> replicable-value 1)
              [:button {:on-click (util/handler (fn []
                                                  (delete-from-replicable-visibility field value-atoms objects)
                                                  (reset! replicable-value-atom (dec replicable-value))))} "Delete"])])]))))

(defn inline-field-group [{value-atoms :value-atoms
                           cta-applies-fn :cta-applies-fn
                           :as options} field]
  [:div.group-fields.o-margin-elements--lg-vertical
   (doall
     (for [subfield (:subfields field)]
       (when (model/is-visible subfield (visibility-value-fn options value-atoms))
         [:div.c-field-inline {:key (get-ref subfield)}
          [:label.c-field-inline__label (when (cta-applies-fn :highlight field) {:class :u-color--highlighted}) (:label subfield)]
          (form-field (assoc options
                        :value-atom (value-atoms (get-ref subfield))
                        :class :c-field-inline__field) subfield)])))])


(defn table-field
  "Renders a composite of row composites as a table: one row per visible row
  field, one column per subfield, headers from the :columns option. Replicable
  rows get a delete button each and an add button below the table (#3192)."
  [{:keys [value-atoms objects entity-value-atoms entity-ref-field-maps] :as options} field]
  (let [visible? (fn [f] (model/is-visible f (visibility-value-fn options value-atoms)))
        atoms (or (:all-value-atoms options) value-atoms)
        rows (filter #(and (visible? %) (some visible? (:subfields %)))
                     (model/filter-by-replicable-visibility (:subfields field) atoms))
        replicable-row (first (filter #(not-empty (:replicable_visibility_ref %)) (:subfields field)))
        replicable-atom (some-> replicable-row :replicable_visibility_ref atoms)
        replicable-count (when replicable-atom
                           (let [n (js/parseInt @replicable-atom)] (if (js/isNaN n) 1 n)))]
    [:div
     [:table.c-table-field
      [:thead
       [:tr
        (for [column (get-in field [:options :columns])]
          [:th {:key column} column])
        (when replicable-atom [:th])]]
      [:tbody
       (doall
         (for [row rows]
           [:tr {:key (:ref row)}
            (when (not-empty (:label row)) [:th (:label row)])
            (doall
              (for [cell (:subfields row)]
                [:td {:key (:ref cell)}
                 (when (visible? cell)
                   (form-field
                     (merge options
                            (let [[mapped-value-atom _ is-entity-linked] (map-value-atom (:collection options) cell
                                                                                        entity-value-atoms entity-ref-field-maps value-atoms)]
                              {:value-atom mapped-value-atom
                               :deleted-value-atom (value-atoms (get-deleted-ref cell))
                               :shared-atom ((:shared-atoms options) (get-ref cell))
                               :disable is-entity-linked}))
                     cell))]))
            (when replicable-atom
              [:td
               ;; Fixed rows mixed with replicable ones cannot be deleted (#3240).
               (when (and (not-empty (:replicable_visibility_ref row)) (> replicable-count 1))
                 [:a.c-table-field__delete.u-color--danger-red
                  {:href "#"
                   :on-click (util/handler (fn []
                                             (delete-from-replicable-visibility row value-atoms objects)
                                             (reset! replicable-atom (dec replicable-count))))}
                  "×"])])]))]]
     (when (and replicable-atom (< replicable-count (:replicable_fields_count replicable-row)))
       [:button {:on-click (util/handler #(reset! replicable-atom (inc replicable-count)))}
        (or (get-in field [:options :add_label]) "Add Another")])]))

(defn percentage-with-units-field [{value-atoms :value-atoms
                                    errors-atom :errors-atom
                                    :as options}
                                   {[percentage-users-field unit-selector-field] :subfields
                                    :as field}]
  (let [field-atom (fn [afield] (value-atoms (get-ref afield)))
        get-units-selected-label (fn [units-selector-atom]
                                   (if units-selector-atom
                                     (cond
                                       (= @units-selector-atom "shares") "Shares"
                                       (= @units-selector-atom "units") "Units"
                                       :else "Percentage")
                                     "Percentage"))]
    [:div
     (when (model/is-visible unit-selector-field (visibility-value-fn options value-atoms))
       [single-choice-field (assoc options
                              :value-atom (field-atom unit-selector-field)
                              :shared-atom ((:shared-atoms options) (:ref unit-selector-field)) ) unit-selector-field])
     [multi-choice-percentage-field (assoc options
                                           :value-atom (field-atom percentage-users-field)
                                           :unit-selector-atom (field-atom unit-selector-field)
                                           :deleted-value-atom (value-atoms (get-deleted-ref percentage-users-field))
                                           :percentage-value-atom (value-atoms (get-percentage-ref percentage-users-field))
                                           :shared-atom ((:shared-atoms options) (:ref percentage-users-field)))
      (assoc percentage-users-field
        :units-selected-label (get-units-selected-label (field-atom unit-selector-field))
        :hide_selected_choices (:hide_selected_choices percentage-users-field))]]))

(defn string-with-units-field  [{value-atoms :value-atoms
                                 errors-atom :errors-atom
                                 :as options}
                                {[unit-selector-field text-field] :subfields
                                 :as field}]
  (let [field-atom (fn [afield] (value-atoms (get-ref afield)))]
    [:div
     [single-choice-field (assoc options
                                 :value-atom (field-atom unit-selector-field)
                                 :single-choice-field-class :u-margin-bottom--xs) unit-selector-field]
     [string-field (assoc options :value-atom (field-atom text-field))]]))


(defn document-field [options field]
  (fail-if-invalid! spec/document-field-options-spec options "Invaid document field options")
  (let [settings     (get-field-settings (:collection options) field)
        document-url (str "/download/documents/")]
    (fn [options field]
      (let [documents ((:objects options) (get-ref field))]
        [:div.c-collection-documents
         [field-error options field]
         (when (and documents (seq @documents))
           [:ul.c-collection-documents__list (doall (for [doc @documents]
                                                      [:li {:key (:id doc)}
                                                       [:button.c-button--round.c-collection-documents__list__delete-button
                                                        (merge
                                                          {:on-click (util/handler
                                                                       (fn []
                                                                         (swap! (:value-atom options) disj (:id doc))
                                                                         (swap! (:deleted-value-atom options) conj (:id doc))
                                                                         (reset! documents (filterv (fn [document] (not= (:id doc) (:id document))) @documents))))
                                                           :href     "#"}
                                                          (when (or (field-disabled? settings) (field-disabled? options)) {:disabled :disabled}))
                                                        "×"]
                                                       [:a {:href (str "#/document/details/" (:id doc))} (:complex_name doc) ] " "
                                                       [:a.u-disc-list__newtab-button
                                                        {:target "_blank"
                                                         :href   (str "#/document/details/" (:id doc))}
                                                        [:img {:src "/static/img/icons/newtab.png"}]]
                                                       (when (show-image-preview field doc)
                                                         [:div.c-document__preview
                                                          [image-view document-url (:download_key doc) {:attachment :no}]])]))])
         (when-not (or (field-disabled? settings) (field-disabled? options))
           (when-not (and (:single_document field) (> (count (seq @documents)) 0))
             [:button.u-margin-top--xs
              (merge
                (when (field-disabled? settings) {:disabled :disabled})
                {:on-click
                 (util/handler
                   (fn []
                     (reset! state/document-add-modal
                       {:enabled true
                        :image (document-field-type field "image")
                        :permitted-groups (:permitted-groups options)
                        :collection-assignable-only true
                        :current @(:value-atom options)
                        :deleted @(:deleted-value-atom options)
                        :paginate true
                        :single-document (:single_document field)
                        :success-cb (fn [docs filter-params select-all]
                                      (if select-all
                                        (->> (document-model/collection-assignable-document-list
                                               {:paginate false
                                                :current @(:value-atom options)
                                                :deleted @(:deleted-value-atom options)}
                                               nil
                                               "complex_name"
                                               filter-params
                                               nil)
                                          (p/map (fn [results]
                                                   (let [current-document-ids (set (map :id @documents))]
                                                     (swap! documents concat (remove
                                                                               (fn [doc] (contains? current-document-ids (:id doc)))
                                                                               (with-complex-names results)))
                                                     (reset! (:value-atom options) (set (map :id @documents)))
                                                     (swap! (:deleted-value-atom options) clojure.set/difference (set (map :id results)))))))
                                        (do
                                          (swap! documents concat docs)
                                          (swap! (:value-atom options) clojure.set/union (set (map #(:id %) docs)))
                                          (swap! (:deleted-value-atom options) clojure.set/difference (set (map #(:id %) docs)))))
                                      (reset! state/document-add-modal {:enabled false}))
                        :back-cb (util/handler (fn []
                                                 (reset! state/document-add-modal {:enabled false})))
                        :collection (:collection options)})))}) (if (document-field-type field "image") "+ Add an image" "+ Add a document")]))]))))

(defn compliance-field [{value-atom :value-atom
                         save-success-atom :save-success-atom
                         skip-change-atom :skip-change-atom
                         changed-atom :changed-atom
                         :as options} field]
  (let [template-groups (atom nil)
        already-applied (atom @value-atom)]
    (reset! value-atom #{})
    (reset! changed-atom false)
    (->> (task-model/templategroup-list (:group_id (:collection options)) "compliance" "name")
         (p/map #(reset! template-groups %))
         (process-error))
    (add-watch save-success-atom :save-success-watch (fn [_ _ olds news]
                                       (when (and (not= olds news) news)
                                         (reset! already-applied (clojure.set/union @value-atom @already-applied))
                                         (reset! skip-change-atom true)
                                         (reset! value-atom #{})
                                         (reset! save-success-atom false))))
    (fn [options field]
      [:div.c-field-compliance 
       [:h3.u-margin-bottom--xs "Apply suggested compliance"]
       [:ul.compliance
        (doall (for [{tgref :ref :as tg}
                     (if-let [template-group-refs (seq (:template_group_refs field))]
                       (filterv #(contains? (into #{} template-group-refs) (:ref %)) @template-groups)
                       @template-groups)]
                 (when (or (:active tg) (contains? @value-atom tgref))
                   [:li {:key (:id tg)}  [:label [:input (merge (when (contains? @already-applied tgref)
                                                                  {:disabled :disabled})
                                                                (set-checked (or (contains? @value-atom tgref) (contains? @already-applied tgref))
                                                                             {:type :checkbox
                                                                              :on-click (fn [ev]
                                                                                          (if (checked? ev)
                                                                                            (swap! value-atom conj tgref)
                                                                                            (swap! value-atom disj tgref)))}))] " " (:name tg)] ])))]])))

(defn collection-field [{:keys [value-atoms
                                deleted-value-atom]
                         :as options} field]
  (let [family-id (get-in options [:collection :group_id])
        value-atom (value-atoms (:ref field))
        unit-selector-field-value-atom (value-atoms (:unit_selector_field_ref field))
        has-units-selected (some-> unit-selector-field-value-atom deref (= "units"))
        tree-assignments (atom nil)
        tree-assignments-to-choices (fn [assignments]
                                      (filterv first (mapv (fn [{:keys [collection-obj]}]
                                                             [(:value collection-obj)
                                                              (:plainLabel collection-obj)]) assignments)))
        shared-atom (:shared-atom options)
        choices (atom (mapv
                        (fn [obj] [(:owner_collection_id obj) (get-in obj [:owner_collection :name])])
                        (field-objects (options-collection-data options) field)))
        set-shared-choices! (fn [cs] (swap! shared-atom assoc :choices cs))
        _ (set-shared-choices! @choices)
        add-selected-collections! (fn [assignments]
                                    ;; For a reason unknown to me, components using @choices do not receive correct value if
                                    ;; @choices is a lazy seq and not evalutated within a watch. Hence 'vec' below.
                                    ;; Doing any other kind of evalution here, like count or print, would also help.
                                    ;; Converting to vector when within the rendering function wouldn't. No idea why.
                                    (swap! (value-atoms (get-objects-ref field))
                                      merge
                                      (into {}
                                        (map (fn [[col-id col-name]]
                                               [(keyword (str col-id)) {:owner_collection {:id col-id
                                                                                           :name col-name} }]) assignments)))
                                    (swap! choices (fn [old-choices]
                                                     (util/uniq-by first (vec (concat old-choices assignments)))))
                                    (swap! value-atom clojure.set/union (set (map first assignments)))
                                    (swap! deleted-value-atom clojure.set/difference (set (map first assignments))))]
    (add-watch tree-assignments :tree-assignments-watch
      (fn [_ _ _ new-assignments]
        (add-selected-collections! (tree-assignments-to-choices new-assignments))))
    (add-watch choices :share-choices #(set-shared-choices! %4))
    (fn [options field]
      (let [refs (seq (:allowed_collection_type_refs field))
            ref-set (set refs)]
        [:div.c-field-multi_choice_with_attrs.o-margin-elements--md-vertical
         [field-error options field]
         (when (and (seq @value-atom) (not (:hide_selected_choices field)))
           [selected-choices-as-table
            (assoc options
              :has-units-selected has-units-selected
              :has-number-field (not-empty (:unit_selector_field_ref field)))
            nil
            (sort-by second (filterv #(contains? @value-atom (first %)) @choices))
            field])
         [nav-search
          {:on-change (fn [e _]
                        (let [selected-option (js->clj e :keywordize-keys true)]
                          (add-selected-collections! [[(:value selected-option) (:label selected-option)]])))
           :placeholder "Type owner collection name"
           :parent-id (get-in options [:collection :group_id])
           :filter-fn (fn [entry]
                        (if (seq refs)
                          (contains? ref-set (get-in entry [:collection_type :ref]))
                          true))
           :value nil}]
         [assignments-edit-modal tree-assignments (catom family-id) (atom nil)
          {:include-inactive-atom (catom false)
           :save-cb (fn [_]
                      ;; Reset so that modal doesn't have anything selected when re-opened
                      (reset! tree-assignments nil))
           :select-from-tree-label "Select from Collection Tree"
           :filter-options (when refs
                             {:collection_template_ref refs})}]]))))

(defn collection-single-choice-field [{:keys [value-atom
                                              deleted-value-atom
                                              objects]
                                       :as options} field]
  (with-let [original-values @value-atom
             family-id (get-in options [:collection :group_id])
             collections (atom nil)
             set-collections! (fn []
                                (reset! collections
                                  (filterv
                             #(contains? @value-atom (:id %))
                             (when-let [col (some-> (objects (:ref field)) deref first :owner_collection)] [col]))))
             _ (set-collections!)
             _ (add-watch value-atom (str "id-collection-" (:ref field))
                 (fn [& _] (set-collections!)))]

    [:div.c-field-multi_choice_with_attrs.o-margin-elements--md-vertical
     [field-error options field]
     (when (seq @collections)
       [:ul.c-collection-documents__list
        (doall (for [col @collections]
                 [:li {:key (:id col)}
                  [:button.c-button--round.c-collection-documents__list__delete-button
                   (merge
                     {:on-click (util/handler
                                  (fn []
                                    (reset! value-atom #{})
                                    (reset! deleted-value-atom original-values)
                                    (reset! collections nil)))
                      :href "#"})
                   "×"]
                  [:a {:href (path-for :collection-details :id (:id col))} (:name col) ] " "
                  [:a.u-disc-list__newtab-button
                   {:target "_blank"
                    :href (path-for :collection-details :id (:id col))}
                   [:img {:src "/static/img/icons/newtab.png"}]]]))])

     [assignments-edit-modal (catom nil) (catom family-id) value-atom
      {:include-inactive-atom (catom false)
       :single-choice true
       :cb (fn [arg]
             (let [col (select-keys arg [:id :name])]
               (reset! deleted-value-atom original-values)
               (swap! (objects (:ref field)) conj {:owner_collection col})
               (reset! value-atom #{(:id col)}))
             (swap! state/collection-tree-modal assoc :enabled false))
       :save-cb (fn [arg]
                  (let [assignment (:collection-obj (first arg))
                        col (when assignment {:id (:value assignment)
                                              :name (:label assignment)})]
                    (when col
                      (reset! deleted-value-atom original-values)
                      (swap! (objects (:ref field)) conj {:owner_collection col})
                      (reset! value-atom #{(:id col)}))))
       :select-from-tree-label "Select from Collection Tree"}]]))

(defn contact-details [options field data-sources id]
  (if-let [det (some-> data-sources (get (keyword (str (:loader_ref field) "_details"))) deref (get id) :component)]
    det
    [:div]))

(defn toggle-id-atom [id-atom]
  (fn [new-id]
    (if (not= new-id @id-atom)
      (reset! id-atom new-id)
      (reset! id-atom nil)) ))

(defn show-unlink-asset-collection-modal! [asset-collection-name options]
  (common/show-action-modal
   (merge
    {:title   (str"Are you sure you want to unlink \"" asset-collection-name "\" asset collection from its parent?")
     :content [:div
               [:p.u-margin-top.u-margin-bottom "To perform this action click unlink and confirm by clicking continue."]]
     :actions [
               {:text      "Unlink"
                :action-cb (fn [] ((:unlink-cb options)))}]}
    options)))

(def type-trust-beneficial-interest "Assets: Trust Beneficial Interest")
(def type-llc-member-interest "Assets: LLC Member Interest")

;; spec: needs collection in options
(defn- asset-collection-controls [options field id]
  (let [id-keyword (keyword (str id))
        value-atom ((-> options :value-atoms ) (get-xval-ref field {:name "asset_collection"}))
        controls (atom (if (get @value-atom id-keyword) :selected :edit))
        collection-name (atom (get-in (field-object-map (options-collection-data options) field) [id-keyword :asset_collection :name] ))
        get-percentage (fn [] (str (or (as-> options v (:value-atoms v) (v (get-percentage-ref field)) (deref v) (id-keyword v)) 0)))
        show-collection-tree-modal (fn [{:keys [has-number-field include-in-name] :as options} collection-tree]
                                     (let [ref-set (set (:asset-collection-type-refs options))]
                                       (reset!
                                         state/collection-tree-modal
                                         {:enabled true
                                          :cb (fn [col]
                                                (swap! state/collection-tree-modal
                                                  assoc :choosen-assignments
                                                  [{:collection (str (:id col))
                                                    :collection-obj (collection-model/to-search-obj col)
                                                    :main false}]
                                                  :disabled-ids #{(:id col)}))
                                          :primary-collection-id (atom nil) ;; search doesn't work when this is absent
                                          :on-save-cb (fn [_]
                                                        (when-let [assignment (-> @state/collection-tree-modal :choosen-assignments first)]
                                                          (->>
                                                            (collection-model/collection-full-details (-> assignment :collection-obj :value))
                                                            (p/map (fn [collection-response]
                                                                     (->>
                                                                       (model/collection-type-form-def (:collection_type_id collection-response))
                                                                       (p/map (fn [form-def]
                                                                                (let [asset-col-form-fields (->> form-def :forms (map :fields) flatten flatten-fields (util/associate-by :ref))
                                                                                      entity-field (asset-col-form-fields "entity")
                                                                                      entity-id (as-> collection-response v (:data v) (v (keyword (:ref entity-field))))
                                                                                      interest-field (asset-col-form-fields (:interest_field_ref entity-field))
                                                                                      asset-col-percentage (str (as-> collection-response v (:data v) (v (keyword (:ref interest-field))) ))
                                                                                      this-percentage (str (get-percentage))]
                                                                                  ;; https://clojureverse.org/t/cond-indentation-readabliity-continuation-syntax-proposal-for-expr/7825
                                                                                  (cond
                                                                                    (and has-number-field entity-id (not= entity-id (-> options :collection :id)))
                                                                                    (js/alert "The collection is already attached to another entity collection.")
                                                                                    ,
                                                                                    (and
                                                                                      has-number-field
                                                                                      (seq asset-col-percentage)
                                                                                      (not= asset-col-percentage this-percentage))
                                                                                    (js/alert "The ownership value in the selected collection does not match the one specified here. Please correct it before selecting the collection.")
                                                                                    ,
                                                                                    :else
                                                                                    (do
                                                                                      (swap! value-atom assoc id-keyword (-> @state/collection-tree-modal :choosen-assignments first :collection))
                                                                                      (reset! collection-name (-> @state/collection-tree-modal :choosen-assignments first :collection-obj :plainLabel))
                                                                                      (swap! state/collection-tree-modal assoc :enabled false)
                                                                                      (reset! controls :selected))))))
                                                                       (process-error))))
                                                            (process-error))))
                                          :tree-items (atom collection-tree)
                                          :options {:single-choice true
                                                    :search-filter-fn (fn [entry]
                                                                        (if (seq (:asset-collection-type-refs options))
                                                                          (contains? ref-set (get-in entry [:collection_type :ref]))
                                                                          true))}
                                          :include-inactive-atom (atom false)
                                          :close-cb #(reset! controls :edit)})))]

    (fn [{:keys [has-number-field include-in-name]
          :as options} _ _]
      (case @controls
        :edit [:div
               [:button
                {:on-click (util/handler
                             (fn []
                               (controller/dispatch
                                 :collection-tree
                                 :load
                                 {:family-id (:family-id options)
                                  :include-inactive false
                                  :filter-options (when (seq (:asset-collection-type-refs options))
                                                    {:collection_template_ref (:asset-collection-type-refs options)})
                                  :cb (fn [collection-tree]
                                        (show-collection-tree-modal options collection-tree))})))}
                "Select"] " "
               [:button
                {:on-click (util/handler
                             (fn []
                               (common/show-modal
                                 :collection-add
                                 [collection-component/collection-details-edit
                                  (merge
                                    {:forms-change-status-atom (atom nil)
                                     :active-form :details
                                     :allow-parent-choice true
                                     :title "Add an asset collection"
                                     :save-new-button-title "Save"
                                     :add-func admin-model/group-admin-collection-add
                                     :collection-type-refs (:asset-collection-type-refs options)
                                     :entity-name (:entity-name options)
                                     :success-cb (fn [collection-add-response]
                                                   (swap! value-atom assoc id-keyword (:id collection-add-response))
                                                   (reset! collection-name (:name collection-add-response))
                                                   (reset! controls :selected)
                                                   (common/hide-modal :collection-add))}
                                    (when (:sync_asset_collection_names field)
                                      {:fixed-name (str (:entity-name options)
                                                     (when has-number-field
                                                       (str
                                                         " "
                                                         (get-percentage)
                                                         (case (:units-selected options)
                                                           "percentage" "%"
                                                           (str  " " (:units-selected options)))))
                                                     (when include-in-name
                                                       (str " " include-in-name)))}))
                                  nil (atom id) (-> options :collection :group_id)]
                                 {:lower-layer true
                                  :close-cb #(reset! controls :edit)})))}
                "Add new"]]
        :selected [:div
                   [:button {:on-click (util/handler (fn []
                                                       (.open js/window (path-for :collection-details :id (@value-atom id-keyword)) "_blank")))}
                    "Open"] " "
                   [:button
                    {:on-click (util/handler
                                (fn []
                                  (show-unlink-asset-collection-modal! 
                                   @collection-name
                                   {:close-cb #(reset! controls :selected)
                                    :unlink-cb (fn []
                                                 (swap! value-atom assoc id-keyword nil)
                                                 (reset! controls :edit))})))} 
                    "Unlink"]]))))

(defn ownership-field [{{family-id :group_id} :collection} _]
  (let [details-id (atom nil)]
    (fn [{:keys [value-atoms
                 data-sources
                 form-fields] :as options} field]
      (let [form-fields-map (util/associate-by :ref form-fields)
            collection-field-ref (:collection_ownership_field_ref field)
            users-field-ref (:user_ownership_field_ref field)
            users-form-field (form-fields-map users-field-ref)
            users-value-atom (value-atoms users-field-ref)
            collection-choices (:choices @(get-in options [:shared-atoms collection-field-ref]))
            collection-value-atom (value-atoms collection-field-ref)
            collection-form-field (form-fields-map collection-field-ref)
            unit-selector-value-atom (value-atoms (:unit_selector_field_ref field))
            unit-selector-choices (:choices (form-fields-map (:unit_selector_field_ref field)))
            has-number-field (if-let [percentage-visibility (:percentage_visibility field)]
                               (model/is-visible
                                 (assoc field
                                   :visibility percentage-visibility)
                                 (visibility-value-fn options value-atoms))
                               (not-empty (:unit_selector_field_ref field))) #_(boolean (seq unit-selector-choices)) ;; TODO: braindead
            toggle-options {:toggle-details (toggle-id-atom details-id)}
            has-units-selected (and has-number-field (not= @unit-selector-value-atom "percentage"))
            get-sort-label (fn [label]
                             (if (vector? label)
                               (nth label 2)
                               label))
            vattrs (model/visible-attrs collection-form-field (fn [ref]
                                                                (model/get-form-value ((:all-segment-ref-field-map options) ref) value-atoms)))
            sort-by-fn (fn [{:keys [label id field]}]                   
                         (conj
                          (vec
                           (for [attr (filter :sortable vattrs)]
                             (str (get @(value-atoms (get-attr-ref field attr)) (keyword (str id))))))
                          (get-sort-label label)))]
        [:div.c-field-multi_choice_with_attrs.o-margin-elements--md-vertical
         (when (or (seq @users-value-atom) (seq @collection-value-atom))
           [multi-field-selected-choices-as-table
            (assoc options
                   :has-units-selected has-units-selected
                   :has-number-field has-number-field
                   :units-selected-label (and has-number-field (second ((util/associate-by first unit-selector-choices) @unit-selector-value-atom)))
                   :controls-label (when-not (:hide_asset_controls collection-form-field)  
                                             (if (empty? (:custom_asset_label collection-form-field))
                                               "Asset Collections"
                                               (:custom_asset_label collection-form-field))))
            toggle-options
            vattrs
            (sort-by sort-by-fn
                     (concat
                      (for [[id label] collection-choices
                            :when (contains? @collection-value-atom id)]
                        {:id id
                         :label label
                         :field collection-form-field
                         :controls (when-not (:hide_asset_controls collection-form-field)
                                     [asset-collection-controls (assoc options
                                                                  :family-id family-id
                                                                  :has-number-field has-number-field
                                                                  :units-selected (and has-number-field @unit-selector-value-atom)
                                                                  :entity-name (-> options :collection :name)
                                                                  :include-in-name (let [attr-value-atom (value-atoms
                                                                                                           (get-attr-ref
                                                                                                             collection-form-field
                                                                                                             (first (filter :include_in_related_collection_name (:attributes collection-form-field)))))]
                                                                                     (when attr-value-atom
                                                                                       (@attr-value-atom (keyword (str id)))))
                                                                  :asset-collection-type-refs (:asset_collection_type_refs collection-form-field))
                                      collection-form-field id])})
                      (for [[id {label :component}] (util/uniq-by first @(data-sources (keyword (:loader_ref users-form-field))))
                            :when (contains? @users-value-atom id)]
                        {:id id
                         :label label
                         :field users-form-field})))
            {:attributes (:attributes collection-form-field)
             :ref collection-field-ref}])
         (contact-details nil users-form-field data-sources @details-id)]))))

(defn bool-field [{value-atom :value-atom
                   :as options} field]
  [:label [:input (set-checked (get-atom-value options value-atom)
                    (merge
                      {:on-click (fn [event] (set-atom-value! options value-atom (checked? event)))}
                      (when (:disable options)
                        {:disabled :disabled})))]
   (when (:show_label field) (:label field))])

(defn label-field [{:keys [value-atom collapsed-atom cta-applies-fn] :as options}
                   {:keys [expander] :as field}]
  [:h4.u-margin-bottom.u-margin-top--lg
   {:class (apply util/classes
             (flatten
               [(when expander
                  [:o-collapsable
                   :u-flex
                   (when @collapsed-atom :is-collapsed)])
                (when  (cta-applies-fn :highlight field) :u-color--highlighted)]))}
   (:label field)
   (when expander [:a.o-collapsable__expander {:on-click (util/handler #(swap! collapsed-atom not))}])])

(defn entity-field [options field]
  (let [ownership (model/get-ownership-info (get-ref field) (:collection options))]
    [:div
     [:input {:disabled :disabled :value (:entity_name ownership)}]
     (when (seq (:units ownership))
           [:div
            [:h4.u-margin-bottom.u-margin-top "Interest"]
            [:select
             {:disabled :disabled}
             [:option (str/capitalize (:units ownership))]]
            [:input.u-margin-top {:disabled :disabled :value (:percentage ownership)}]])]))

(def field-types {:string {:component string-field
                           :from-value #(util/to-value %)
                           :to-value #(util/to-value %)}
                  :number {:component number-field
                           :from-value #(util/to-value %)
                           :to-value #(util/to-value %)}
                  :multi_choice {:component multi-choice-field
                                 :from-value #(into #{} %)
                                 :to-value #(util/to-vector %)
                                 :replace-conf [:delete]}
                  :multi_choice_with_attrs {:component (fn [options field]
                                                         (multi-choice-field (assoc options :as-table true) field))
                                            :from-value #(into #{} %)
                                            :to-value #(into [] %)
                                            :replace-conf [:delete]}
                  :multi_choice_percentage {:component multi-choice-percentage-field
                                            :from-value #(into #{} %)
                                            :to-value #(into [] %)
                                            :ref-types [:ref :deleted-ref :percentage-ref]
                                            :replace-conf [:delete]}
                  :percentage_with_units {:component percentage-with-units-field
                                          :from-value #(into #{} %)
                                          :to-value #(into [] %)}
                  :string_with_units {:component string-with-units-field
                                      :from-value #(util/to-value %)
                                      :to-value #(util/to-value %)}
                  :multi_choice_with_other {:component multi-choice-with-other-field
                                            :from-value #(into #{} %)
                                            :to-value #(into [] %)
                                            :replace-conf [:delete]}
                  :single_choice_with_other {:component (fn [options field]
                                                          (single-choice-with-other-field (assoc options :as-table true) field))
                                             :from-value #(first %)
                                             :to-value #(util/to-value %)
                                             :replace-conf [:delete]}
                  :date {:component date-field
                         :from-value #(when (not-empty %) (tz/parsed-date-to-browser-date (time-coerce/to-date (util/parse-datetime %))))
                         :to-value #(and % (util/local-date-time-to-date-string %))}
                  :month_day {:component month-day-field
                              :from-value identity
                              :to-value identity}
                  :address {:component address-field}
                  :intl_address {:component intl-address-field}
                  :jurisdiction {:component field-group}
                  :field_group {:component field-group}
                  :document {:component document-field
                             :from-value #(into #{} %)
                             :to-value #(into [] %)
                             :replace-conf [:delete :objects]}
                  :single_choice {:component single-choice-field
                                  :from-value #(first %)
                                  :to-value #(util/to-vector %)}
                  :compliance {:component compliance-field
                               :from-value #(into #{} %)
                               :to-value #(into [] %)}
                  :bool {:component bool-field
                         :from-value identity
                         :to-value identity}
                  :label {:component label-field
                          :from-value identity
                          :to-value identity}
                  :foreign_tin {:component (fn [options field]
                                             (inline-field-group (assoc options
                                                                        :single-choice-field-class :c-field-inline__field) field))
                                :from-value #(into #{} %)
                                :to-value #(into [] %)}
                  :due_date_or_pair {:component inline-field-group}
                  :inline_field_group {:component inline-field-group}
                  :table_field {:component table-field}
                  :export {:component export-field
                           :from-value identity
                           :to-value   identity}
                  :collection {:component collection-field
                               :from-value #(into #{} %)
                               :to-value #(into [] %)
                               :extra-values [{:name "asset_collection"
                                               :type :number}]}
                  :collection_single {:component collection-single-choice-field
                                      :from-value #(into #{} %)
                                      :to-value #(into [] %)
                                      :replace-conf [:delete :objects]}
                  :ownership {:component ownership-field
                              :from-value #(util/to-value %)
                              :to-value #(util/to-value %)}
                  :entity {:component entity-field
                           :from-value #(util/to-value %)
                           :to-value #(util/to-value %)}
                  :static {:from-value #(util/to-value %)
                           :to-value #(util/to-value %)}})

(defn field-error [options field]
  [:span.error (@(:errors-atom options) (keyword (:ref field)))])

(defn delete-from-replicable-visibility [field-group value-atoms objects]
  (let [start (-> (model/get-refs field-group) first (str/split #"_") last js/parseInt)
        end (:replicable_fields_count field-group)
        replace-suffix (fn [ref index]
                         (str/replace ref #"_\d+$" (str "_" index)))
        in-replace-conf? (fn [key field]
                           (contains? (set (get-in field-types [(field-type field) :replace-conf])) key))
        set-delete-atoms (fn [field index current-atom replace-atom]
                           (when (in-replace-conf? :delete field)
                             (reset! (value-atoms (str (replace-suffix (get-ref field) index) "__delete")) @current-atom)
                             (when-not (= index end)
                               (reset! (value-atoms (str (replace-suffix (get-ref field) (inc index)) "__delete")) @replace-atom))))
        set-objects (fn [field index]
                      (let [current-objects (objects (replace-suffix (get-ref field) index))
                            replace-objects (objects (replace-suffix (get-ref field) (inc index)))]
                        (when (in-replace-conf? :objects field)
                          (reset! current-objects (when-not (= index end) @replace-objects)))))
        replace-atoms (fn [field index]
                        (let [current-atom (value-atoms (replace-suffix (get-ref field) index))
                              replace-atom (value-atoms (replace-suffix (get-ref field) (inc index)))]
                          (set-delete-atoms field index current-atom replace-atom)
                          (set-objects field index)
                          (reset! current-atom (when-not (= index end) @replace-atom))))]
    ;; Up to and including the last row, so the row the others move into is cleared.
    (doseq [index (range start (inc end))]
      (doseq [field (flatten-fields [field-group])]
        (replace-atoms field index)))))

(defn coltype-template-data-sources [collection-atom
                                      permitted-users-atom
                                      roles-atom]
  {:context_permitted_users
   (track!
     (fn []
       (mapv (fn [user]
               [(:id user) {:component
                            [:span
                            (when (:is_contact user) {:class "contact"})
                            (auth-model/get-full-name user true)]
                            :object user}])
         (util/distinct-by :id @permitted-users-atom))))
   ,
   :context_permitted_company_contacts
   (track!
     (fn []
       (mapv (fn [user]
               [(:id user) {:component [:span
                            (when (:is_contact user) {:class "contact"})
                            (:company_name user)]
                            :object user}])
         (sort-by
           :company_name
           (filterv #(and (seq (:company_name %))
                       (str/blank? (:first_name %))
                       (str/blank? (:last_name %))) (util/distinct-by :id @permitted-users-atom))))))
   ,
   :context_permitted_users_details
   (track!
     (fn []
       (into {} (mapv (fn [user] [(:id user) {:component [auth-component/user-info-container user]
                                              :object user}])
                  @permitted-users-atom))))
   ,
   :context_permitted_company_contacts_details
   (track!
     (fn []
       (into {} (mapv (fn [user] [(:id user) {:component [auth-component/user-info-container user]
                                              :object user}])
                  @permitted-users-atom))))
   ,
   :director_roles
   (track!
     (fn []
       (mapv (fn [role] [(:id role) {:component [:span nil (:name role)]
                                     :object role}])
         (filterv #(= (:type %) "director") @roles-atom)) ))
   ,
   :officer_roles
   (track!
     (fn []
       (mapv (fn [role] [(:id role) {:component [:span nil (:name role)]
                                     :object role}])
         (filterv #(= (:type %) "officer") @roles-atom))))
   ,
   :collection_subtype_name
   (track! (fn [] (get-in @collection-atom [:collection_type :name])))} )
